'use strict';

var primitiveSet = require('es5-ext/object/primitive-set')
  , eol          = require('./ws-eol')
  , inline       = require('./ws-inline');

module.exports = primitiveSet.apply(null,
	Object.keys(eol).concat(Object.keys(inline)));



//////////////////
// WEBPACK FOOTER
// ./~/esniff/lib/ws.js
// module id = 438
// module chunks = 54